export const parseTs = (v?: string | number | null) => {
  if (v == null) return Number.NaN;
  if (typeof v === 'number') return Number.isFinite(v) ? v : Number.NaN;
  const n = Number(v);
  if (!Number.isNaN(n)) return n;
  const p = Date.parse(v);
  return Number.isNaN(p) ? Number.NaN : p;
};


